import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Flame } from "lucide-react";
import { useNavigate } from "react-router-dom";

const urgencyMessages = [
  "Only 2 slots left this weekend!",
  "Saturday almost full!",
  "Limited availability this month",
  "3 artists booked today!",
];

export default function UrgencyBar() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentMessage, setCurrentMessage] = useState(urgencyMessages[0]);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has dismissed the bar
    const hasDismissed = sessionStorage.getItem("urgencyBar_dismissed");
    if (hasDismissed) return;

    // Show after 5 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);

    // Rotate messages every 10 seconds
    const rotateInterval = setInterval(() => {
      setCurrentMessage(prev => {
        const currentIndex = urgencyMessages.indexOf(prev);
        return urgencyMessages[(currentIndex + 1) % urgencyMessages.length];
      });
    }, 10000);

    return () => {
      clearTimeout(timer);
      clearInterval(rotateInterval);
    };
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    sessionStorage.setItem("urgencyBar_dismissed", "true");
  };

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -50, opacity: 0 }}
        className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-red-600 via-orange-500 to-red-600"
      >
        <div className="flex items-center justify-center h-6 px-3">
          <div className="flex items-center gap-1.5">
            <Flame className="w-3 h-3 text-white animate-pulse" />
            <span className="text-[11px] text-white font-medium">{currentMessage}</span>
            <span 
              onClick={() => navigate('/booking')}
              className="bg-white text-red-600 text-[10px] font-bold px-1.5 rounded-sm cursor-pointer hover:bg-white/90"
              style={{ lineHeight: '14px' }}
            >
              Book
            </span>
          </div>
          <button
            onClick={handleDismiss}
            className="absolute right-2 text-white/70 hover:text-white"
          >
            <X className="w-3 h-3" />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
